import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';


@Component({ template: '' })

export abstract class BaseItemViewComponent<TItem> extends BaseComponent {
  @Input() item: TItem;
}
